import { useSelector } from "react-redux";
import { RootState } from "../state/store";

const useAuth = () => {
  const { token, userId, type, login } = useSelector(
    (state: RootState) => state.auth
  );
  const {
    id,
    full_name,
    email,
    membership_type,
    role,
    avatar,
    is_verified_email,
    modules,
  } = useSelector((state: RootState) => state.user);

  const isLoggedIn = !!token && !!login;

  return {
    token,
    userId,
    type,
    login,
    isLoggedIn,
    id,
    full_name,
    email,
    membership_type,
    role,
    avatar,
    is_verified_email,
    // State persisted before this field existed has no `modules` key
    modules: modules ?? null,
  };
};

export default useAuth;
